export default "__VITE_ASSET__001fb967__"